// src/components/Layout.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, LogOut, Users } from 'lucide-react';

const JourniLogo = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 200 200" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M120 30 L120 120 Q120 150 90 150 L70 150" fill="#10b981" />
    <path d="M140 30 L160 30 Q170 30 170 40 L170 80" fill="#10b981" />
    <path d="M50 130 L70 150 L70 170 Q70 180 60 180 L40 180 Q30 180 30 170 L30 130 Z" fill="#10b981" />
    <circle cx="90" cy="130" r="20" fill="white" />
    <circle cx="90" cy="130" r="12" fill="#10b981" />
  </svg>
);

export default function Layout({ children }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <div 
              onClick={() => navigate('/dashboard')} 
              className="flex items-center gap-2 cursor-pointer">
              <JourniLogo />
              <h1 className="text-xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
                Journi
              </h1>
            </div>
            <div className="flex items-center gap-2">
              <button className="p-2 hover:bg-gray-100 rounded-lg relative">
                <Bell className="w-5 h-5 text-gray-600" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
              </button>
              <button 
                onClick={() => navigate('/profile')}
                className="p-2 hover:bg-gray-100 rounded-lg">
                <Users className="w-5 h-5 text-gray-600" />
              </button>
              <button 
                onClick={() => {
                  localStorage.removeItem('token');
                  navigate('/');
                }}
                className="p-2 hover:bg-gray-100 rounded-lg">
                <LogOut className="w-5 h-5 text-gray-600" />
              </button>
              <div className="w-9 h-9 bg-emerald-500 rounded-full flex items-center justify-center text-white text-sm font-semibold">
                AK
              </div>
            </div>
          </div>
        </div>
      </header>
      {children}
    </div>
  );
}